<div>
  <kodit-field
    fieldLabel="Datum">
    <kodit-calendar
      [formCtrl]="form.controls.datum!"
      class="p-fluid"
      formCtrlId="date"
    ></kodit-calendar>
  </kodit-field>
</div>
